import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const BulkAssignModal = ({ isOpen, onClose, onAssign, ticketCount }) => {
  const [technicians, setTechnicians] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [assigning, setAssigning] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTechnicians();
      setSelected(null);
    }
  }, [isOpen]);

  const fetchTechnicians = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase?.from('personnel')?.select('id, name, role')?.order('name');
      if (!error) setTechnicians(data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async () => {
    if (!selected) return;
    setAssigning(true);
    await onAssign(selected);
    setAssigning(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl border border-border shadow-elevation-3 w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-lg font-heading font-semibold text-foreground">Assign Technician</h2>
            <p className="text-sm text-muted-foreground mt-1">Assign to {ticketCount} selected ticket{ticketCount !== 1 ? 's' : ''}</p>
          </div>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground transition-smooth">
            <Icon name="X" size={20} color="currentColor" />
          </button>
        </div>
        <div className="p-6">
          {loading ? (
            <div className="flex justify-center py-8">
              <Icon name="Loader" size={24} color="var(--color-primary)" className="animate-spin" />
            </div>
          ) : (
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {technicians?.map(tech => (
                <button
                  key={tech?.id}
                  onClick={() => setSelected(tech)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border transition-smooth text-left ${
                    selected?.id === tech?.id
                      ? 'border-primary bg-primary/10' :'border-border hover:bg-muted'
                  }`}
                >
                  <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon name="User" size={16} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">{tech?.name}</p>
                    <p className="text-xs text-muted-foreground">{tech?.role}</p>
                  </div>
                  {selected?.id === tech?.id && (
                    <Icon name="Check" size={16} color="var(--color-primary)" className="ml-auto" />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="flex justify-end gap-3 p-6 border-t border-border">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button
            variant="default"
            onClick={handleAssign}
            disabled={!selected || assigning}
            iconName={assigning ? 'Loader' : 'UserCog'}
            iconPosition="left"
          >
            {assigning ? 'Assigning...' : 'Assign'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkAssignModal;
